import { ENTITY_TYPE, FLOW_TYPE } from './flows';
import { PATHS } from './paths';

const {
	APPROPRIATENESS,
	CREDIT_CHECK,
	INTERESTS,
	MANDATE,
	NETBANK,
	PARENTS,
	PRODUCTS,
	RISKQ_RESULTS,
	SIGN,
	SIGNING_AUTHORITY,
	SUITABILITY
} = PATHS;

const APPROPRIATENESS_STEPS = [`${APPROPRIATENESS}_1`, `${APPROPRIATENESS}_2`, `${APPROPRIATENESS}_3`];
const RISKQ_STEPS = [...APPROPRIATENESS_STEPS, `${SUITABILITY}_1`, `${SUITABILITY}_2`];

export const PROGRESS_BAR_STEPS = {
	[ENTITY_TYPE.INDIVIDUAL]: {
		[FLOW_TYPE.AV]: [...APPROPRIATENESS_STEPS, CREDIT_CHECK, PRODUCTS, SIGN],
		[FLOW_TYPE.EB]: [...RISKQ_STEPS, RISKQ_RESULTS, MANDATE, INTERESTS, SIGN],
		[FLOW_TYPE.ER]: [...RISKQ_STEPS, MANDATE, INTERESTS, SIGN],
		[FLOW_TYPE.MV]: [...APPROPRIATENESS_STEPS, MANDATE, SIGN],
		[FLOW_TYPE.ES_MV]: [PARENTS, MANDATE, SIGN],
		[FLOW_TYPE.RR_EB]: [...RISKQ_STEPS, RISKQ_RESULTS],
		[FLOW_TYPE.RR_ER]: [...RISKQ_STEPS],
		[FLOW_TYPE.RR_MV]: [...APPROPRIATENESS_STEPS],
		[FLOW_TYPE.RR_SU]: [`${APPROPRIATENESS}_1`]
	},
	[ENTITY_TYPE.LEGAL_ENTITY]: {
		[FLOW_TYPE.AV]: [...APPROPRIATENESS_STEPS, CREDIT_CHECK, PRODUCTS, MANDATE, SIGNING_AUTHORITY, SIGN],
		[FLOW_TYPE.EB]: [...RISKQ_STEPS, RISKQ_RESULTS, NETBANK, MANDATE, INTERESTS, SIGNING_AUTHORITY, SIGN],
		[FLOW_TYPE.ER]: [...RISKQ_STEPS, NETBANK, MANDATE, INTERESTS, SIGNING_AUTHORITY, SIGN],
		[FLOW_TYPE.MV]: [...APPROPRIATENESS_STEPS, NETBANK, MANDATE, SIGNING_AUTHORITY, SIGN],
		[FLOW_TYPE.ES_MV]: [PARENTS, MANDATE, SIGN],
		[FLOW_TYPE.RR_EB]: [...RISKQ_STEPS, RISKQ_RESULTS],
		[FLOW_TYPE.RR_ER]: [...RISKQ_STEPS],
		[FLOW_TYPE.RR_MV]: [...APPROPRIATENESS_STEPS],
		[FLOW_TYPE.RR_SU]: [`${APPROPRIATENESS}_1`]
	}
};
